// All SVG Imports
import Logo from './svg/logo.svg'
import HomeBold from './svg/home-bold.svg'
import NewCampaignBold from './svg/new-campaigne-bold.svg'
import ManageBold from './svg/manage-bold.svg'
import Analytics from './svg/analytics.svg'
import UserIcon from './svg/user.svg'
import RecentUserFilled from './svg/user 3 1.svg'
import RecentUserLined from './svg/user2 2.svg'
import Logout from './svg/logout.svg'
import UserProfile from './svg/user-profile.svg'
import Delete from './svg/delete.svg'
import Search from './svg/seach.svg'
import Close from './svg/close.svg'
import List from './svg/list.svg'
import List2 from './svg/list2.svg'
import UserList from './svg/userList.svg'
import Master from './svg/master.svg'
import BusinessListIcon from './svg/business-list.svg'
import UserAccessIcon from './svg/user-access.svg'
import PackageIcon from './svg/package.svg'
import RightCircleArrow from './svg/right-circle-arrow.svg'
import RightArrow from './svg/right-arrow.svg'
import Login from './svg/login.svg'
import ArrowDown from './svg/arrow-down.svg'
import AddCircle from './svg/add_circle.svg'
import createNew from './svg/create-new.svg'
import templateIcon from './svg/templates.svg'
import themeIcon from './svg/theme.svg'
import imageIcon from './svg/images.svg'
import userProfileIcon from './svg/user-profile-icon.svg'
import whatsAppIcon from './svg/whatsapp-icon.svg'
import creditIcon from './svg/credit-icon.svg'
import supportIcon from './svg/support-icon.svg'
import articleIcon from './svg/article-icon.svg'
import healthArticleIcon from './svg/health-article-icon.svg'

import recentIcon from './svg/recent-time.svg'
import Clock from './svg/clock.svg'
import ArrowUp from './svg/arrow-up.svg'
import editIcon from './svg/edit.svg'
import uploadIcon from './svg/file-upload.svg'
import pauseIcon from './svg/pauseIcon.svg'
import InfoIcon from './svg/info.svg'
import ViewIcon from './svg/view.svg'
import MarkEmailReadIcon from './svg/mark_email_read.svg'
import MarkEmailReadIconWhite from './svg/mark_email_read_white.svg'
import MarkEmailUnReadIcon from './svg/mark_email_unread.svg'
import Archive from './svg/archive.svg'
import UnArchive from './svg/unarchive.svg'
import ArchiveWhite from './svg/archive-white.svg'
import UnArchiveWhite from './svg/unarchive-white.svg'
import Upload from './svg/upload.svg'
import CopyIcon from './svg/copy.svg'
import Resend from './svg/reSend.svg'
import verticalMenu from './svg/verticalMenu.svg'
import bell from './svg/bell.svg'
import burgerMenu from './svg/burger-menu.svg'
import adminIcon from './svg/admin-logo.svg'
import DownloadIcon from './svg/download.svg'
import UserProfileGreyIcon from './svg/user-profile-grey.svg'
import EditFileIcon from './svg/file-edit.svg'
import UploadWhiteIcon from './svg/upload-white.svg'
import CloseErrorIcon from './svg/close-error.svg'
import TickSuccessIcon from './svg/check-success.svg'
import CloseGreyIcon from './svg/icons8-close.svg'
import BackIcon from './svg/back-icon.svg'
import coin from './svg/coin.svg'
import HistoryWhiteIcon from './svg/history-white.svg'
import blogButtonIcon from './svg/majesticons_article-line.svg'
import blogButtonIconWhite from './svg/majesticons_article-line_white.svg'

import pressArticleButtonIcon from './svg/stash_article.svg'
import authoredArticleButtonIcon from './svg/material-symbols_article-person-outline.svg'
import socialMediaPostButtonIcon from './svg/material-symbols_perm-media-outline.svg'
import authoredArticleWhiteButtonIcon from './svg/material-symbols_article-person-outline-white.svg'
import socialMediaPostWhiteButtonIcon from './svg/material-symbols_perm-media-outline-white.svg'
import generateButtonIcon from './svg/f7_sparkles.svg'
import customizationIcon from './svg/material-symbols_dashboard-customize-outline-rounded.svg'
import attachmentsIcon from './svg/tdesign_attach.svg'
import chatUserIcon from './svg/gg_profile.svg'
import copyIcon from './svg/iconamoon_copy.svg'
import likeIcon from './svg/iconamoon_like.svg'
import likeFilledIcon from './svg/likeFilled.svg'
import dislikeIcon from './svg/iconamoon_dislike.svg'
import dislikeFilledIcon from './svg/dislikeFilled.svg'
import repeatIcon from './svg/pajamas_retry.svg'
import profileIcon from './svg/profile.svg'
import profileIcon2 from './svg/profile.svg'
import humetaLogo from './svg/humeta_logo.svg'
import scientificOpinion from './svg/scientific_opinion_icon.svg'
import healthFaqsIcon from './svg/health-faqs-icon.svg'
import patientEducationIcon from './svg/patient-education-icon.svg'
import scientificLblIcon from './svg/scientific-lbl-icon.svg'
import visualAidIcon from './svg/visual-aid-icon.svg'
import reportIcon from './svg/report-icon.svg'
import GenerateIcon from './svg/generate-icon.svg'
import uploadNewIcon from './svg/upload-icon.svg'
import micIcon from './svg/mic-icon.svg'
import soundIcon from './svg/soundwave.svg'
import cloudDownloadIcon from './svg/cloud_download.svg'
import cloudCopyIcon from './svg/cloudCopyIcon.svg'

const assets = {
  images: {
    shotLogo: require('./images/shot-logo.png'),
    shotLogoNew: require('./images/shot-logo-new.jpg'),

    grayLogo: require('./images/gray_logo.png'),
    digitalMarketing: require('./images/digital-marketing.png'),
    socialNetwork: require('./images/social-network.png'),
    instaPost: require('./images/post.png'),
    postLinked: require('./images/postLinked.png'),
    twitter: require('./images/twitter.png'),
    email: require('./images/email.png'),
    blog: require('./images/blog.png'),
    pressRelease: require('./images/press-release.png'),
    bullhorn: require('./images/bullhorn.png'),
    whatsapp: require('./images/whatsapp.png'),
    // Faisal
    whatsapp1: require('./images/whatsapp1.png'),
    whatsappImg: require('./images/whatsapp-img.png'),
    crownImg: require('./images/crown-img.png'),
    profileImg: require('./images/profile-img.png'),
    clockImg: require('./images/historyTimeImg.png'),

    ads: require('./images/ads.png'),
    printer: require('./images/printer.png'),
    research: require('./images/research.png'),
    likes: require('./images/likes.png'),
    webPage: require('./images/web-page.png'),
    contentMarketing: require('./images/content-marketing.png'),
    contract: require('./images/contract.png'),
    bellIcon: require('./images/bellIcon.png'),
    appIcon: require('./images/appIcon.png'),
    notificationNumber: require('./images/notificationNumber.png'),
    webLogo: require('./images/logo-web.png'),
    webLogoNew: require('./svg/humeta_logo.svg'),

    emailDark: require('./images/email-dark.png'),
    phoneDark: require('./images/smartphone.png'),
    singleStarIcon: require('./images/single-star.png'),
  },
  humeta_new_flow:{
    scientifc_article: require('./png/scientific_article.png'),
    health_blog: require('./png/health_blog.png'),
    press_release: require('./png/press_release.png'),
    feature_article: require('./png/feature_article.png'),
    marketing_emailer: require('./png/emailer.png'),
    social_media_post: require('./png/social_media_post.png'),
    patient_education: require('./png/patient_education_lit.png'),
    visual_aid: require('./png/visual_aid.png'),
    scientific_lbl: require('./png/scientific_article.png'),
    health_faqs: require('./png/health_blog.png'),
  }
}

export default assets

// All SVG exports
export {
  Logo,
  HomeBold,
  NewCampaignBold,
  ManageBold,
  Analytics,
  UserIcon,
  Logout,
  UserProfile,
  RecentUserFilled,
  RecentUserLined,
  Delete,
  Search,
  Close,
  List,
  UserList,
  Master,
  BusinessListIcon,
  PackageIcon,
  UserAccessIcon,
  RightCircleArrow,
  RightArrow,
  Login,
  ArrowDown,
  ArrowUp,
  editIcon,
  uploadIcon,
  pauseIcon,
  InfoIcon,
  ViewIcon,
  MarkEmailReadIcon,
  MarkEmailReadIconWhite,
  MarkEmailUnReadIcon,
  Archive,
  ArchiveWhite,
  UnArchive,
  UnArchiveWhite,
  Upload,
  CopyIcon,
  Resend,
  verticalMenu,
  bell,
  burgerMenu,
  adminIcon,
  DownloadIcon,
  UserProfileGreyIcon,
  EditFileIcon,
  UploadWhiteIcon,
  CloseErrorIcon,
  TickSuccessIcon,
  CloseGreyIcon,
  BackIcon,
  HistoryWhiteIcon,
  blogButtonIcon,
  blogButtonIconWhite,
  pressArticleButtonIcon,
  authoredArticleButtonIcon,
  socialMediaPostButtonIcon,
  generateButtonIcon,
  customizationIcon,
  attachmentsIcon,
  chatUserIcon,
  copyIcon,
  likeIcon,
  dislikeIcon,
  repeatIcon,
  dislikeFilledIcon,
  likeFilledIcon,
  coin,
  AddCircle,
  createNew,
  templateIcon,
  themeIcon,
  imageIcon,
  userProfileIcon,
  whatsAppIcon,
  creditIcon,
  supportIcon,
  articleIcon,
  healthArticleIcon,
  GenerateIcon,
  recentIcon,
  Clock,
  profileIcon,
  List2,
  authoredArticleWhiteButtonIcon,
  socialMediaPostWhiteButtonIcon,
  humetaLogo,
  scientificOpinion,
  healthFaqsIcon,
  patientEducationIcon,
  scientificLblIcon,
  visualAidIcon,
  reportIcon,
  uploadNewIcon,
  micIcon,
  soundIcon,
  cloudDownloadIcon,
  cloudCopyIcon
}
